/**
 * How many booking requests of eight the screen keeps in flight at once (SSD-7525 decision 4). One today: each request
 * already books four at a time on the server, and YunExpress shares its key with web order bookings. Raise it only
 * once a production run of 150 shows the wait is worth it; a carrier's rate limit sends the rest of the run back to one.
 */
export const BOOKING_LANES = 1;

const RATE_LIMITED = /\b429\b|too many requests|rate.?limit/i;

/** Whether a booking answer or a failed request reads as the carrier's (or the route's) rate limit. */
export const looksRateLimited = (text: string | null | undefined): boolean => RATE_LIMITED.test(text ?? '');

/**
 * Runs `work` over `chunks` in order, up to `lanes` at a time. `work` answers whether its chunk met a rate limit; once
 * one did, the rest go one at a time. `stop` is asked before each round, and the answer is how many chunks were started,
 * so the caller can let go of the rest.
 */
export async function runBookingLanes<T>(
  chunks: T[],
  lanes: number,
  work: (chunk: T) => Promise<boolean>,
  stop: () => boolean,
): Promise<number> {
  let started = 0;
  let width = Math.max(1, Math.trunc(lanes));
  while (started < chunks.length) {
    if (stop()) {
      return started;
    }
    const round = chunks.slice(started, started + width);
    started += round.length;
    const limited = await Promise.all(round.map(work));
    if (limited.some(Boolean)) {
      width = 1;
    }
  }
  return started;
}
